import { render, staticRenderFns } from "./PricePlanCard.vue?vue&type=template&id=51a30618&"
import script from "./PricePlanCard.vue?vue&type=script&lang=js&"
export * from "./PricePlanCard.vue?vue&type=script&lang=js&"
import style0 from "./PricePlanCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports